/*
 * TableTypes.ts  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";

export enum TABLE_SORT {
	ASC = "asc",
	DESC = "desc"
}

export type TableCellAlign = "left" | "center" | "right";

export interface ITableColumn {
	id: string;
	label?: React.ReactNode;
	sortable?: boolean;
	headerAlign?: TableCellAlign;
	width?: string;
}

export interface ITableSortConfig {
	columnId: string;
	direction: TABLE_SORT;
}

export interface ITableState {
	sort: ITableSortConfig[];
	selectionIds?: string[];
}

export interface ITableColumnConfig {
	id: string;
	sortable?: boolean;
	sortActive?: boolean;
	sortDirection?: TABLE_SORT;
	headerAlign?: TableCellAlign;
	width?: string;
}
